import { theme } from "../theme";
import { positionColor } from "../utils";

// ── Největší propady za zvolené období ────────────────────────────────────────
export default function BiggestDrops({ drops = [], days, onDaysChange, onOpen, loading }) {
  return (
    <div style={{
      background: theme.bg, border: `1.5px solid ${theme.line}`,
      borderRadius: theme.rCard, boxShadow: theme.shadowSm,
      display: "flex", flexDirection: "column",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 11, padding: "20px 22px 14px" }}>
        <span style={{
          width: 32, height: 32, borderRadius: theme.rTile, flexShrink: 0,
          background: theme.badSoft, color: theme.bad,
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>
        </span>
        <span style={{ fontSize: 16, fontWeight: 800, color: theme.ink, flex: 1, whiteSpace: "nowrap" }}>Největší propady</span>
        <select
          value={days}
          onChange={e => onDaysChange(Number(e.target.value))}
          style={{
            padding: "6px 10px", borderRadius: theme.rBtn, border: `1px solid ${theme.line}`,
            background: theme.bg, color: theme.inkSoft, fontSize: 12.5, fontWeight: 600,
            fontFamily: "inherit", cursor: "pointer", outline: "none",
          }}
        >
          {[7, 30, 90].map(d => <option key={d} value={d}>{d} dní</option>)}
        </select>
      </div>

      <div style={{ padding: "0 14px 14px" }}>
        {loading && <p style={{ padding: "18px 8px", fontSize: 13.5, color: theme.mut, textAlign: "center" }}>Načítám…</p>}
        {!loading && drops.length === 0 && (
          <div style={{ padding: "26px 12px 22px", textAlign: "center" }}>
            <div style={{
              width: 40, height: 40, borderRadius: theme.rTile, margin: "0 auto 12px",
              background: theme.okSoft, color: theme.ok,
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
            </div>
            <p style={{ fontSize: 13.5, color: theme.inkSoft, fontWeight: 600 }}>Žádný propad</p>
            <p style={{ fontSize: 12.5, color: theme.mut, marginTop: 3 }}>Za zvolené období žádný produkt neklesl.</p>
          </div>
        )}
        {!loading && drops.map(d => (
          <div key={d.product_id} onClick={() => onOpen && onOpen(d.product_id)} style={{
            display: "flex", alignItems: "center", gap: 12,
            padding: "10px 8px", borderRadius: theme.rCard, cursor: onOpen ? "pointer" : "default",
          }}
            onMouseEnter={e => { e.currentTarget.style.background = theme.bgSoft; }}
            onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}>
            <span style={{
              minWidth: 42, padding: "5px 9px", borderRadius: theme.rTile, flexShrink: 0,
              background: theme.bgSoft, color: positionColor(d.position),
              fontSize: 13, fontWeight: 700, textAlign: "center", fontVariantNumeric: theme.tnum,
            }}>#{d.position}</span>
            <div style={{ minWidth: 0, flex: 1 }}>
              <p style={{ fontSize: 13.5, fontWeight: 600, color: theme.ink, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{d.name}</p>
              {d.group_name && <p style={{ fontSize: 11.5, color: theme.mut, marginTop: 1 }}>{d.group_name}</p>}
            </div>
            <span style={{ fontSize: 14, fontWeight: 700, color: theme.bad, fontVariantNumeric: theme.tnum, flexShrink: 0 }}>
              −{d.drop}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
